///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2024
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React, { useState } from "react";

import Modal from "../../Modal";
import DownloadIcon from "../../icons/DownloadIcon";
import Spinner from "../../icons/Spinner";
import ExcelIcon from "../../icons/ExcelIcon";
import {
  mode as modeType,
  division as divisionType
} from "../../../helpers/types";
import { getLanesTemplate } from "../../../api/lanes";
import saveFile from "../../../helpers/saveFile";
import messages from "../../../helpers/messages";

const Template = ({ name, progress, handleDownloadTemplate }) => (
  <div
    data-testid="template-row"
    onClick={handleDownloadTemplate}
    className="grid-hover px-24"
  >
    <div
      style={{ width: 400, padding: "10px 0px" }}
      className="one whole pos-relative border-bottom-grey"
    >
      <ExcelIcon
        className="align-top"
        height="27px"
        width="24px"
        fill="#007732"
      />
      <b className="pl-4 pt-4 pos-absolute">{name}</b>
      {progress ? (
        <Spinner className="spinner fr mt-4" height="12px" width="12px" />
      ) : (
        <DownloadIcon
          className="fr pt-4 hover-part"
          height="16px"
          width="16px"
        />
      )}
    </div>
  </div>
);

export const DownloadTemplateModal = ({
  handleClose,
  isCoyoteBid,
  bidModes
}) => {
  const tlFileName = messages.tlFileName.defaultMessage;
  const tlFileNameV2 = messages.tlFileNameV2.defaultMessage;
  const imdlFileName = messages.imdlFileName.defaultMessage;
  const ltlFileName = messages.ltlFileName.defaultMessage;

  const [tlProgress, toggleTlProgress] = useState(false);
  const [tlProgressV2, toggleTlProgressV2] = useState(false);
  const [imdlProgress, toggleImdlProgress] = useState(false);
  const [ltlProgress, toggleLtlProgress] = useState(false);

  const handleDownloadTemplate = (
    mode,
    progress,
    toggleProgress,
    templateVersion,
    division,
    enableTruckloadLaneImportV2,
    fileName
  ) => {
    if (!progress) {
      toggleProgress(true);
      getLanesTemplate(division, mode, templateVersion, enableTruckloadLaneImportV2, fileName)
        .then(response => {
          toggleProgress(false);
          saveFile(response.data, fileName);
        })
        .catch(() => toggleProgress(false));
    }
  };

  const isTlBid = bidModes?.includes(modeType.tl);
  const isLtlBid = bidModes?.includes(modeType.ltl);
  const isImdlBid = bidModes?.includes(modeType.imdl);

  return (
    <Modal
      title={messages.templateDownload.defaultMessage}
      open={true}
      handleClose={handleClose}
      titleClass="modal__title_light uppercase"
      closeButtonClass="modal__close-button mr-24 mt-16"
      bodyClass="border-top-grey pb-12"
    >
      {isTlBid && isCoyoteBid !== false && (
        <Template
          name={tlFileName}
          progress={tlProgress}
          handleDownloadTemplate={() =>
            handleDownloadTemplate(
              modeType.tl,
              tlProgress,
              toggleTlProgress,
              1,
              divisionType.coy,
              false,
              tlFileName
            )
          }
        />
      )}
      {isTlBid && isCoyoteBid === false && (
        <Template
          name={tlFileNameV2}
          progress={tlProgressV2}
          handleDownloadTemplate={() =>
            handleDownloadTemplate(
              modeType.tl,
              tlProgressV2,
              toggleTlProgressV2,
              2,
              divisionType.coy,
              true,
              tlFileNameV2
            )
          }
        />
      )}
      {isLtlBid && (
        <Template
          name={ltlFileName}
          progress={ltlProgress}
          handleDownloadTemplate={() =>
            handleDownloadTemplate(
              modeType.ltl,
              ltlProgress,
              toggleLtlProgress,
              1,
              divisionType.coy,
              false,
              ltlFileName
            )
          }
        />
      )}
      {isImdlBid && (
        <Template
          name={imdlFileName}
          progress={imdlProgress}
          handleDownloadTemplate={() =>
            handleDownloadTemplate(
              modeType.imdl,
              imdlProgress,
              toggleImdlProgress,
              1,
              divisionType.coy,
              false,
              imdlFileName
            )
          }
        />
      )}
    </Modal>
  );
};

export default DownloadTemplateModal;
